import React from 'react';
import PreviewSectionWidget from "./components/previewSection/PreviewSection-widget";
import ControlsSectionWidget from "./components/controlsPanel/ControlsSection-widget";

import './styles/app.scss'

function App() {
  return (
    <section className="App">
        <section className="body">
            <PreviewSectionWidget />
            <ControlsSectionWidget />
        </section>
    </section>
  );
}

export default App;
